"use client";

import { usePathname } from "next/navigation";

export function LayoutShell({
  navbar,
  footer,
  bottomNav,
  hasBottomNav,
  children,
}: {
  navbar: React.ReactNode;
  footer: React.ReactNode;
  bottomNav?: React.ReactNode;
  hasBottomNav?: boolean;
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isLanding = pathname === "/";

  return (
    <>
      {!isLanding && navbar}
      <main
        id="main"
        className={`min-h-screen ${!isLanding ? "pt-16" : ""} ${hasBottomNav && !isLanding ? "pb-14 sm:pb-0" : ""}`}
      >
        {children}
      </main>
      {!isLanding && footer}
      {bottomNav}
    </>
  );
}
